import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import { ModalBase } from '@components/Modal';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 564,
        height: 350,
        '@media (max-width: 600px)': {
            height: 'var(--100vh)',
            width: '100%',
        },
    },
});

export const Content = styled('div')({
    padding: '24px 16px',
    display: 'grid',
    gridGap: '8px',
    gridTemplateColumns: '100%',
});

export const LocationWrapper = styled('div')({
    display: 'grid',
    rowGap: '8px',
    gridTemplateColumns: 'calc(100% - 40px)',
    '@media (max-width: 600px)': {
        gridTemplateColumns: '90%',
        gridGap: '16px',
    },
});

export const StyledIconButton = styled(IconButton)({
    position: 'absolute',
    right: '-40px',
    top: '5px',
    padding: '4px',
    '& svg path': {
        fill: 'rgba(0, 0, 0, 0.6)',
    },
});
